<google-map [options]="options" width="992px"></google-map>
